import { atom, getDefaultStore, useAtomValue } from 'jotai';
import { QuerySitesResult, QuerySitesState } from '../../../types/querySites';

export const querySitesStateAtom = atom<QuerySitesState>({
  result: null,
  isLoading: false,
});

export const setQuerySitesResult = (result: QuerySitesResult | null) => {
  const store = getDefaultStore();
  store.set(querySitesStateAtom, (prev) => ({ ...prev, result }));
};

export const setQuerySitesLoading = (isLoading: boolean) => {
  const store = getDefaultStore();
  store.set(querySitesStateAtom, (prev) => ({ ...prev, isLoading }));
};

export const useQuerySitesResult = () => useAtomValue(querySitesStateAtom).result;

export const useQuerySitesLoading = () => useAtomValue(querySitesStateAtom).isLoading;

export const useQuerySitesUrl = () => useAtomValue(querySitesStateAtom).result?.url;
